import React from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Alert, Box, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';
import Spinner from '~/components/Common/Spinner';

import { useGetCampaign } from '~/hooks/apis/accommodation/useCampaigns';

import CampaignBreadcrumbs from './components/CampaignBreadcrumbs';
import CampaignForm from './components/CampaignForm';

function AccommodationCampaignEditPage() {
  const { campaignId } = useParams<{ campaignId: string }>();
  const { data: campaign, isLoading, error } = useGetCampaign({ campaignId });

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <Container maxWidth="md">
        <Alert severity="error">Failed to load campaign: {error.message}</Alert>
      </Container>
    );
  }

  if (!campaign) {
    return (
      <Container maxWidth="md">
        <Alert severity="warning">Campaign not found.</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Helmet>
        <title>Edit Campaign: {campaign.name}</title>
      </Helmet>

      <CampaignBreadcrumbs currentPage={`Edit Campaign: ${campaign.name}`} />
      <PageHeader title={`Edit Campaign: ${campaign.name}`} />

      <Box mt={3}>
        {/* Keyed on the fields the form initialises from — after a mutation the campaign query is
            invalidated and refetched, producing a new key that remounts the form with fresh data. */}
        <CampaignForm
          key={`${campaign.name}::${campaign.displayName ?? ''}::${campaign.subtitle ?? ''}::${campaign.status}::${campaign.propertyIds.join(',')}::${JSON.stringify(campaign.schedules)}`}
          campaign={campaign}
        />
      </Box>
    </Container>
  );
}

export default AccommodationCampaignEditPage;
